import React from "react";

// TAMPILAN-SOQ: true on phone-width screens (below Tailwind's md, 768 px).
// Used where a page shows cards instead of a table on a phone; only one of
// the two is rendered, so buttons and data-testids appear once.
const MQ = "(max-width: 767px)";

export default function useLayarKecil() {
  const cocok = () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(MQ).matches : false);
  const [kecil, setKecil] = React.useState(cocok);
  React.useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const m = window.matchMedia(MQ);
    const ubah = (e) => setKecil(e.matches);
    if (m.addEventListener) m.addEventListener("change", ubah);
    else m.addListener(ubah);
    return () => (m.removeEventListener ? m.removeEventListener("change", ubah) : m.removeListener(ubah));
  }, []);
  return kecil;
}
